import { type ReactNode } from "react";

import { cn } from "@btnet/utilities-core";

import { useGridContainerStickyHeight } from "commonComponents/utilities/Grid/useGridContainerStickyHeight";

import "./GridContainerStationaryHeader.less";

export const GridContainerStationaryHeader = (props: {
    children: ReactNode;
    withMap?: boolean;
}) => {
    const { children, withMap } = props;
    const stationaryHeaderRef = useGridContainerStickyHeight(
        "--grid-container-stationary-header-height",
    );

    return (
        <div
            className={cn("GridContainerStationaryHeader", {
                "GridContainerStationaryHeader--withMap": withMap,
            })}
            ref={stationaryHeaderRef}
        >
            {children}
        </div>
    );
};
